import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { useForm, useFormState } from 'react-final-form';
import { getRegions } from '../../../../../api/queries';
import { setError } from '../../../../../actions';
import { setCoordinates } from '../../../../../utils/helpers/common';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { SelectProps } from '../types';
import { LocationsSelect } from '../LocationsSelect';

export const RegionSelect: React.FC<SelectProps> = ({
  setInitCoordinates,
  setShouldRenderMap
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { change } = useForm();
  const { values } = useFormState();

  const currentLocationId = values[FORM_VALUES.locationId];
  const locationName = values[FORM_VALUES.locationName];
  const cityId = values[FORM_VALUES.cityId] || '';

  const locationsQueryVariables = { cityId };
  const { data, loading, error } = useQuery(getRegions, {
    variables: locationsQueryVariables
  });

  const regionsData = data?.regions || [];

  const onChangeRadioHandler = (e?: React.ChangeEvent<HTMLInputElement>) => {
    const locationId = e?.target.value;
    change(FORM_VALUES.locationId, locationId);
    const locationData = regionsData.find(
      location => location.id === locationId
    );
    change(FORM_VALUES.locationName, locationData?.name?.trim());
    change(FORM_VALUES.villageId, undefined);
    change(FORM_VALUES.villageName, undefined);
    setCoordinates(locationData, setInitCoordinates);
    setShouldRenderMap(false);
    change(FORM_VALUES.coordinates, '');
  };

  useEffect(() => {
    if (error) dispatch(setError(true));
  }, [error]);

  const selectTitleAndPlaceholder = t('new_ad.district');
  const selectAndModalCypress = 'item-form-location';

  return (
    <LocationsSelect
      loading={loading}
      inputStat="item-form-find-region"
      inputPlaceholder={t('new_ad.find_district')}
      selectCypress={selectAndModalCypress}
      modalCypress={selectAndModalCypress}
      selectTitleAndPlaceholder={selectTitleAndPlaceholder}
      selectValue={locationName}
      contentContainerCypress="item-form-location__container"
      radioCypress="location"
      radioName="select-location"
      currentValue={currentLocationId}
      data={regionsData}
      fieldName={FORM_VALUES.locationId}
      errorCypress="location-id-field-error"
      onSelect={onChangeRadioHandler}
    />
  );
};
